import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, TextField } from "@material-ui/core";

import { useStore } from "@store/store";
import Loader from "@components/loader";
import {
  UPDATE_PRELOAD_CHARGE,
  UPDATE_PRELOAD_CHARGE_SUCCESS,
  UPDATE_PRELOAD_CHARGE_FAILURE,
} from "@utils/actionTypes";
import API from "@services/axios";
import { allowOnlyFloat } from "@utils/commonFunctions";
import { preloadStyle } from "./style";

function Preload(props) {
  const classes = preloadStyle();
  const [state, dispatch] = useStore();
  // Note: Get preload should be taken from customerByID data
  const [data, setData] = useState(
    state.customer?.customerByIdData?.preloadCharge
  );
  const [error, setError] = useState("");
  const { id } = useParams();

  const handleChange = (e) => {
    setData(e.target.value);
  };

  const handleBlur = (e) => {
    if (e.target.value === "") setError("preload is required");
    else if (e.target.value > 1000000)
      setError("preload must not be more than 1000000");
    else setError("");
  };

  // Update preload and validation for preload
  const handleSubmit = () => {
    if (data === "") setError("preload is required");
    else if (data > 1000000) setError("preload must not be more than 1000000");
    else {
      setError("");
      dispatch({
        type: UPDATE_PRELOAD_CHARGE,
      });
      API.patch(`customers/${id}/saveData`, {
        preloadCharge: data === null ? 0 : data,
      })
        .then((response) => {
          dispatch({
            type: UPDATE_PRELOAD_CHARGE_SUCCESS,
            payload: response.data.data,
          });
          toast.success("Preload Updated Successfully");
          props.getCustomer();
        })
        .catch((error) => {
          dispatch({ type: UPDATE_PRELOAD_CHARGE_FAILURE, payload: error });
          toast.error(error?.response?.data?.message);
        });
    }
  };
  return (
    <>
      <div className={classes.preloadWrapper}>
        <div className="weekly-row-wrapper">
          <Loader loading={state?.customer?.updatingPreloadCharge} />
          <div className="weekly-row">
            <label className="label-text">Preload Charge ($)</label>
            <div className="textfield-wrapper1">
              <TextField
                id="fuel"
                name="fuel"
                className="fuel"
                variant="outlined"
                type="text"
                placeholder="Charge"
                onKeyPress={allowOnlyFloat}
                value={data === null ? 0 : data}
                onChange={handleChange}
                error={true}
                helperText={error}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>

        <Button
          className="blue-btn primary-btn"
          color="inherit"
          disableElevation
          underlinenone="true"
          onClick={handleSubmit}
        >
          Save
        </Button>
      </div>
    </>
  );
}
export default Preload;
